"use strict";

module.exports = function () {
  this.selectedRows = this.data;
  return this.selectedRows;
};